import type { Theme } from "../../theme";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PhysicsHole from "src/components/Hole/PhysicsHole";
import LanguageSelector from "src/components/LanguageSelector";
import { generatePlayerId } from "src/utils/generateRoomCode";

const buttonStyle = (theme: Theme) => ({
  ...theme.button,
  width: 160,
  textAlign: "center" as const,
  boxShadow: "0 1px 1px 1px",
  marginTop: theme.gridUnit * 5
});

type Props = {
  path: string;
};

const Home = (props: Props): ReactNode => {
  const { t } = useTranslation();
  useEffect(() => {
    // Get or create player ID from localStorage
    let storedPlayerId = localStorage.getItem("bao_player_id");
    if (!storedPlayerId) {
      storedPlayerId = generatePlayerId();
      localStorage.setItem("bao_player_id", storedPlayerId);
    }
  }, []);

  return (
    <div
      css={({ gridUnit }: Theme) => ({
        position: "fixed" as const,
        left: 0,
        top: gridUnit * 5,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column" as const
      })}
    >
      <PhysicsHole holeWidth={300} holeHeight={300} seeds={32} side={1} />
      <a css={buttonStyle} href="/game">
        {t("home.playSage")}
      </a>
      <a css={(theme: Theme) => ({ ...buttonStyle(theme), display: "none" })} href="/multiplayer">
        {t("home.playMultiplayer")}
      </a>
      <a css={buttonStyle} href="/game/help">
        {t("home.howToPlay")}
      </a>
      <a css={buttonStyle} href="/contact">
        {t("home.feedback")}
      </a>
      <div css={(theme: Theme) => ({ marginTop: theme.gridUnit * 5 })}>
        <LanguageSelector label={t("common.language")} />
      </div>
    </div>
  );
};

export default Home;
